import { SharedModule } from '@uw/shared/shared.module';
import { AngularMaterialModule } from '@uw/shared/material.module';
import { RouterModule } from '@angular/router';
import { ThemeBaseComponent } from './base/theme-base.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SubheaderComponent } from './subheader/subheader.component';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorPageComponent } from './content/error-page/error-page.component';
import { SidebarMenuComponent } from './sidebar-menu/sidebar-menu.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        AngularMaterialModule,
        TranslateModule,
        SharedModule,
        HeaderComponent,
        FooterComponent,
        ThemeBaseComponent,
        SidebarComponent,
        SubheaderComponent,
        ErrorPageComponent,
        SidebarMenuComponent,
    ],
    exports: [
        HeaderComponent,
        FooterComponent,
        ThemeBaseComponent,
        SidebarComponent,
        SubheaderComponent,
    ],
})
export class ThemesModule {}
